<app-larged-tuile
  icon="fa-kit fa-picto-filtration-vs"
  [title]="'dashboard.filtrationvs' | translate"
  [buttons]="getButtons()"
  [status]="getStatus() | translate"
  [mode]="
    this.actionStack!.getValue('fvsCModeFonctionnement') === 2
      ? P0003601ProgrammeFiltrationAuto[
          this.actionStack!.getValue('fvsCProgrammeFiltrationAuto')
        ].value
      : ''
  "
  [statusMode]="
    this.actionStack!.getValue('fvsSAlarme') === 1
      ? 'alarm'
      : getButtons()[this.actionStack!.getValue('fvsCModeFonctionnement')]
          .status!
  "
  [selectItem]="this.actionStack!.getValue('fvsCModeFonctionnement')"
  (onPressSetting)="this.openProductModal()"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.FiltrationVS_Controle,
      'fvsCModeFonctionnement',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-larged-tuile>
